import { c as _c } from "react/compiler-runtime";
import SvgWello from '@common/icon/SvgWello';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
interface ContentsListItemProps {
  imageUrl: string;
  title: string;
  summary: string;
  timeAgo?: string;
  href: string;
  priority?: boolean;
}
export const ContentsListItem = t0 => {
  const $ = _c(24);
  const {
    imageUrl,
    title,
    summary,
    timeAgo,
    href,
    priority: t1
  } = t0;
  const priority = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("group block rounded-large transition-opacity duration-200 ease-out", "hover:opacity-80", "active:opacity-80", "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = imageUrl || "/images/placeholder.png";
  const t4 = title || "\uCF58\uD150\uCE20 \uC774\uBBF8\uC9C0";
  let t5;
  if ($[1] !== priority || $[2] !== t3 || $[3] !== t4) {
    t5 = <Image src={t3} alt={t4} fill={true} sizes="(max-width: 768px) 100vw, 335px" className="object-cover" preload={priority} />;
    $[1] = priority;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute bottom-20 right-20 size-32 rounded-pill bg-Gray-white flex-center"><SvgWello className="size-16 text-Gray-black" /></div>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5) {
    t7 = <div className="relative mb-24 aspect-[335/223] w-full overflow-hidden rounded-xlarge">{t5}{t6}</div>;
    $[6] = t5;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== title) {
    t8 = <p className="line-clamp-2 overflow-hidden text-ellipsis whitespace-normal font-700 text-Gray-black typo-body2">{title}</p>;
    $[8] = title;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== timeAgo) {
    t9 = timeAgo ? <p className="shrink-0 font-400 text-Gray-500 typo-caption1">{timeAgo}</p> : null;
    $[10] = timeAgo;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <div className="mb-12 flex justify-between gap-8">{t8}{t9}</div>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = summary || "\uB0B4\uC6A9\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.";
  let t12;
  if ($[15] !== t11) {
    t12 = <p className="line-clamp-2 overflow-hidden text-ellipsis whitespace-normal font-400 text-Gray-600 typo-body4">{t11}</p>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t10 || $[18] !== t12) {
    t13 = <div className="mobile-tablet:px-12">{t10}{t12}</div>;
    $[17] = t10;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== href || $[21] !== t13 || $[22] !== t7) {
    t14 = <CustomLink href={href} className={t2}>{t7}{t13}</CustomLink>;
    $[20] = href;
    $[21] = t13;
    $[22] = t7;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
};